module.exports = __webpack_public_path__ + "img/location.f64e3c08.svg";